import { useAtom } from "jotai";
import { FormEvent } from "react";
import { CarPart } from "types/CarPart";

import { selectedDamagedPartsAtom } from "atoms/damageReview";

export const useDamagedPartsList = () => {
  const [damagedParts, setDamagedParts] = useAtom(selectedDamagedPartsAtom);

  const handleSubmit = (onSubmit: (data: CarPart[]) => void) => (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(damagedParts);
  };

  const setDamagedPart = (key: CarPart, checked: boolean) => {
    if (!checked && damagedParts.includes(key)) {
      const newDamagedParts: CarPart[] = damagedParts.filter((damagedPart) => damagedPart !== key);

      setDamagedParts(newDamagedParts);
    } else if (!damagedParts.includes(key)) {
      setDamagedParts([...damagedParts, key]);
    }
  };

  return { damagedParts, setDamagedPart, handleSubmit };
};
